import React from 'react';
import RawHTML from '~/components/jsx-helpers/raw-html';
import { usePutAway } from '../../shared';
import './sticky-note.scss';
export default function StickyNote({ stickyData }) {
    const [closed, PutAway] = usePutAway();
    if (!stickyData || closed || stickyData.mode !== 'emergency') {
        return null;
    }
    return (React.createElement("div", { className: "sticky-note", "data-analytics-view": true, "data-analytics-nudge": "emergency", "data-nudge-placement": "banner" },
        React.createElement("div", { className: "text-content", role: "alert" },
            React.createElement(PutAway, null),
            React.createElement(RawHTML, { className: "html-content", html: stickyData.emergency_content }))));
}
